import { useContext } from 'react';

import { SelectChangeEvent } from '@mui/material';

import { SelectInput } from '@/components/common/select_input/SelectInput';
import { ConfigContext } from '@/Contexts/ConfigContext';
import { PartnerDashboardDetailsProps } from '@/models/PartnerDashboard';

type StateSelectProps = {
  disabled: boolean;
  required?: boolean;
  hasError: boolean;
  label: string;
  value: string;
  partnerInfo: PartnerDashboardDetailsProps;
  patchPartner: (patch: Partial<PartnerDashboardDetailsProps>) => void;
};

export function StateSelect({
  disabled,
  required = true,
  hasError,
  label,
  value,
  partnerInfo,
  patchPartner,
}: StateSelectProps) {
  const { stateSelectOptions } = useContext(ConfigContext);

  const handleStateChange = (e: SelectChangeEvent) => {
    let newStateId: string | null = null;
    let newStateName: string | null = partnerInfo?.stateName ?? null;
    let newCountyId: string | null = partnerInfo?.countyId ?? null;
    let newCountyName: string | null = partnerInfo?.countyName ?? null;

    if (e.target.value != null) {
      newStateId = e.target.value;
      newStateName =
        stateSelectOptions.find((option) => option.value === e.target.value)?.label ?? null;
    }

    if (newStateId !== partnerInfo?.stateId) {
      newCountyId = null;
      newCountyName = null;
    }

    patchPartner({
      stateId: newStateId,
      stateName: newStateName,
      countyId: newCountyId,
      countyName: newCountyName,
    });
  };

  return (
    <SelectInput
      disabled={disabled}
      required={required}
      hasError={hasError}
      id='state-select'
      label={label}
      value={value}
      selectOptions={stateSelectOptions}
      onChange={handleStateChange}
    />
  );
}
